<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Clients</h2>
        </span>
      </span>

      <div class="col-lg-12 newclient-screen-hgt">
        <div class="m-3">
          <form [formGroup]="clientForm">
            <div class="row adduser-container-hgt">
              <div class="col-4" formGroupName="basicInformation">
                <div class="gray-bg-rounded">
                  <h2>Basic Information</h2>
                  <div class="col">
                    <div class="d-flex gap-2 d-flex align-items-end mb-2">
                      <div class="col-12 form-group has-float-label">
                        <label for="Caccount">Client Account</label>
                        <input
                          jniAutoCompleteBlocker
                          name="Caccount"
                          type="text"
                          pInputText
                          class="form-control"
                          formControlName="customerAccountD365"
                          id="Caccount"
                          [ngClass]="{
                            'textboxcolor-gray': customerAccountNumberStatus,
                          }"
                          [(ngModel)]="customerAccount" />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex gap-2 align-items-end">
                    <div class="col-10 form-group has-float-label mb-2">
                      <jni-program
                        [parent]="clientForm"
                        (programEvent)="getProgram($event)"
                        (smallLoaderEvent)="getSmallLoaderStatus($event)"
                        [programName]="programName">
                      </jni-program>
                    </div>
                    <div class="col-2 mb-2">
                      <p-button
                        label="Add"
                        icon="pi pi-plus"
                        (click)="showAddProgramSideBar()" />
                    </div>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label for="Caccount"
                      >Client name <span class="madatory-field">*</span></label
                    >
                    <input
                      jniAutoCompleteBlocker
                      type="text"
                      pInputText
                      class="form-control"
                      placeholder=""
                      formControlName="nameAliasD365"
                      id="Caccount"
                      name="Caccount"
                      [ngClass]="{ 'has-error': formErrors['nameAliasD365'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['nameAliasD365']">
                      {{ formErrors["nameAliasD365"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label for="knownAsD365">Known As</label>
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      name="knownAsD365"
                      id="knownAsD365"
                      type="text"
                      placeholder=""
                      class="form-control"
                      formControlName="knownAsD365"
                      [ngClass]="{ 'has-error': formErrors['knownAsD365'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['knownAsD365']">
                      {{ formErrors["knownAsD365"] }}
                    </span>
                  </div>

                  <div
                    class="prospects-panel d-flex col-12 mb-4 mt-4 me-1 ms-2">
                    <label class="p-0 d-flex align-items-center col-6">
                      Uses 3rd Party Warehouse<span class="madatory-field"
                        >*</span
                      >
                    </label>
                    <label class="ms-2 p-0 d-flex align-items-center col-3">
                      <p-radiobutton
                        class="me-2"
                        name="uses3PLWarehouse"
                        value="uses3PLCheckedYes"
                        formControlName="uses3PLWarehouse"
                        [disabled]="isRadioButtonDisabled"
                        (onClick)="onUses3PLInvCheck(true)" />
                      <span>Yes</span>
                    </label>
                    <label class="p-0 d-flex align-items-center me-5 col-3">
                      <p-radiobutton
                        class="me-2"
                        name="uses3PLWarehouse"
                        value="uses3PLCheckedNo"
                        formControlName="uses3PLWarehouse"
                        [disabled]="isRadioButtonDisabled"
                        (onClick)="onUses3PLInvCheck(false)" />
                      <span>No</span>
                    </label>
                  </div>

                  <div class="prospects-panel d-flex col-12 mb-4 me-1 ms-2">
                    <label class="p-0 d-flex align-items-center col-6">
                      Nadel Owned Inventory<span class="madatory-field">*</span>
                    </label>
                    <label class="ms-2 p-0 d-flex align-items-center col-3">
                      <p-radiobutton
                        id="Open"
                        class="me-2"
                        name="nadelOwnedInventory"
                        formControlName="nadelOwnedInventory"
                        value="nadelOwnInvCheckedYes"
                        [disabled]="isRadioButtonDisabled"
                        (onClick)="onNadeOwnInvCheck(true)" />
                      <span>Yes</span>
                    </label>
                    <label class="p-0 d-flex align-items-center me-5 col-3">
                      <p-radiobutton
                        id="Open"
                        class="me-2"
                        name="nadelOwnedInventory"
                        value="nadelOwnInvCheckedNo"
                        formControlName="nadelOwnedInventory"
                        [disabled]="isRadioButtonDisabled"
                        (onClick)="onNadeOwnInvCheck(false)" />
                      <span>No</span>
                    </label>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label>Type <span class="madatory-field">*</span></label>
                    <p-select
                      pInputText
                      id="partyTypeD365"
                      formControlName="partyTypeD365"
                      [options]="typeList"
                      optionLabel="typeDescription"
                      optionValue="typeDescription"
                      [ngClass]="{ 'has-error': formErrors['partyTypeD365'] }"
                      (onBlur)="logValidationErrors()"
                      placeholder="Select a contact type">
                    </p-select>

                    <span class="error-msg" *ngIf="formErrors['partyTypeD365']">
                      {{ formErrors["partyTypeD365"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label>BC</label>
                    <p-select
                      pInputText
                      id="bcUserDefaultSelectionId"
                      formControlName="brandingConsultantD365"
                      [(ngModel)]="bcUserDefaultSelectionId"
                      (onChange)="
                        onBcUserChangeSelection(bcUserDefaultSelectionId)
                      "
                      [options]="bcList"
                      optionLabel="personalNumberProjectName"
                      optionValue="personnelNumber"
                      [ngClass]="{ 'has-error': formErrors['partyTypeD365'] }"
                      (onBlur)="logValidationErrors()"
                      placeholder="BC">
                      <ng-template let-item #item>
                        {{ item.personnelNumber }} : {{ item.projectName }}
                      </ng-template>
                    </p-select>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label>BAC</label>
                    <p-select
                      pInputText
                      id="bacUserDefaultSelectionId"
                      formControlName="brandingAccountCordinator"
                      [(ngModel)]="bacUserDefaultSelectionId"
                      [options]="bacList"
                      optionLabel="personalNumberProjectName"
                      optionValue="personnelNumber"
                      [ngClass]="{ 'has-error': formErrors['partyTypeD365'] }"
                      (onBlur)="logValidationErrors()"
                      placeholder="BAC">
                      <ng-template let-item #item>
                        {{ item.personnelNumber }} : {{ item.name }}
                      </ng-template>
                    </p-select>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label
                      >Client Origin<span class="madatory-field">*</span></label
                    >
                    <p-select
                      pInputText
                      id="sourceD365"
                      formControlName="source"
                      [options]="sourceList"
                      optionLabel="sourcetype"
                      optionValue="sourcetype"
                      [ngClass]="{ 'has-error': formErrors['source'] }"
                      (onBlur)="logValidationErrors()"
                      [filter]="true"
                      [showClear]="true">
                      <ng-template let-item #item>
                        {{ item.sourcetype }}
                      </ng-template>
                    </p-select>
                    <span class="error-msg" *ngIf="formErrors['source']">
                      {{ formErrors["source"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label
                      >Client Group <span class="madatory-field">*</span></label
                    >
                    <p-select
                      pInputText
                      id="customerGroupIdD365"
                      formControlName="customerGroupIdD365"
                      [options]="customerGroupList"
                      optionLabel="descriptionD365"
                      optionValue="customerGroupIdD365"
                      [ngClass]="{
                        'has-error': formErrors['customerGroupIdD365'],
                      }"
                      (onBlur)="logValidationErrors()"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>

                    <span
                      class="error-msg"
                      *ngIf="formErrors['customerGroupIdD365']">
                      {{ formErrors["customerGroupIdD365"] }}
                    </span>
                  </div>

                  <div class="mb-4 po-small">
                    <div class="form-group has-float-label">
                      <label for="parentCompanyName">Parent company name</label>
                      <input
                        jniAutoCompleteBlocker
                        #parentCompanyInput
                        type="text"
                        autocomplete="off"
                        pInputText
                        class="form-control"
                        formControlName="rsmJNIParentCompanyNameD365"
                        id="parentCompanyName"
                        name="rsmJNIParentCompanyNameD365"
                        (click)="op.toggle($event)"
                        (input)="searchClient$.next($any($event.target).value)"
                        (keyup)="op.show($event)"
                        (keydown.Tab)="parentValidation($event, op)" />
                    </div>
                    <p-popover
                      #op
                      [showTransitionOptions]="'0ms'"
                      [hideTransitionOptions]="'0ms'"
                      [target]="parentCompanyInput"
                      [appendTo]="'body'"
                      [showCloseIcon]="false">
                      <div class="surface-overlay">
                        <p-table
                          #dt
                          [value]="clientLists"
                          styleClass="p-datatable-customers po-small"
                          scrollHeight="350px"
                          stripedRows
                          [rowHover]="true"
                          [scrollable]="true"
                          [resizableColumns]="true"
                          [size]="'small'"
                          [rowHover]="true"
                          [rows]="10"
                          [showCurrentPageReport]="true"
                          [rowsPerPageOptions]="[10, 25, 50]"
                          [paginator]="false"
                          [filterDelay]="0"
                          styleClass="table-listing">
                          <ng-template pTemplate="header">
                            <tr class="table-head">
                              <th class="name">Client</th>
                              <th class="vaccount">Account</th>
                              <th class="phone">Street</th>
                              <th class="city">City</th>
                              <th class="state">State</th>
                              <th class="country">Last order date</th>
                            </tr>
                          </ng-template>
                          <ng-template
                            pTemplate="body"
                            let-clientList
                            let-rowIndex="rowIndex">
                            <tr
                              class="p-selectable-row mousepointer"
                              (click)="onClientSelection(clientList)">
                              <td class="name mousepointer">
                                {{ clientList.name }}
                              </td>
                              <td class="vaccount mousepointer">
                                {{ clientList.clientAccount }}
                              </td>
                              <td class="sname mousepointer">
                                {{ clientList.street }}
                              </td>
                              <td class="city mousepointer">
                                {{ clientList.city }}
                              </td>
                              <td class="state mousepointer">
                                {{ clientList.state }}
                              </td>
                              <td class="country mousepointer">
                                {{
                                  clientList.lastOrderDate | date: "MM-dd-yyyy"
                                }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="20">No client found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </p-popover>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label for="Caccount">DUNS#</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      name="DUNS#"
                      id="DUNS#"
                      placeholder=""
                      formControlName="dUNSNoD365"
                      id="Caccount"
                      [ngClass]="{ 'has-error': formErrors['dUNSNoD365'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['dUNSNoD365']">
                      {{ formErrors["dUNSNoD365"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label for="currency">Currency</label>
                    <p-select
                      pInputText
                      id="currency"
                      formControlName="salesCurrencyCodeD365"
                      [options]="currencyList"
                      [optionLabel]="'isoCurrencyCodeD365'"
                      [optionValue]="'isoCurrencyCodeD365'"
                      [ngClass]="{ 'has-error': formErrors['currencyD365'] }"
                      (onBlur)="logValidationErrors()"
                      [showClear]="true"
                      [showFilter]="true">
                    </p-select>
                  </div>

                  <div class="form-group has-float-label mb-4 mb-2">
                    <label for="Caccount"
                      >Company URL<span class="madatory-field">*</span></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      id="name"
                      name="name"
                      formControlName="companyUrl"
                      [ngClass]="{ 'has-error': formErrors['companyUrl'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['companyUrl']">
                      {{ formErrors["companyUrl"] }}
                    </span>
                  </div>

                  <div class="row">
                    <div class="col mb-4">
                      <div class="form-group switcher">
                        <label class="form-label d-block mb-2" for="rcCheck"
                          >Request Credit Check</label
                        >
                        <div
                          class="form-check form-switch d-flex align-items-center gap-2 m-0 form-switch-hgt">
                          <p-toggleswitch
                            id="flexSwitchCheckDefault"
                            name="flexSwitchCheckDefault"
                            formControlName="isRequestCreditCheck" />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckDefault">
                            {{
                              this.clientForm.get([
                                "basicInformation",
                                "isRequestCreditCheck",
                              ])?.value
                            }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col mb-4">
                      <div class="form-group switcher">
                        <label
                          class="form-label d-block mb-2 text-nowrap"
                          for="rcCheck"
                          >Client PO number required</label
                        >
                        <div
                          class="form-check form-switch d-flex align-items-center gap-2 m-0 form-switch-hgt">
                          <p-toggleswitch
                            id="flexSwitchCheckDefault1"
                            formControlName="customerPORequired" />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckDefault1">
                            {{ this.clientForm.value.customerPORequired }}
                            {{
                              this.clientForm.get([
                                "basicInformation",
                                "customerPORequired",
                              ])?.value
                            }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mb-4">
                      <div class="form-group switcher">
                        <label class="form-label d-block mb-2" for="resale"
                          >Resale</label
                        >
                        <div
                          class="form-check form-switch d-flex align-items-center gap-2 m-0 form-switch-hgt">
                          <p-toggleswitch
                            formControlName="isResale"
                            (change)="onResaleEnabled($event)"
                            id="flexSwitchCheckDefault2" />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckDefault2">
                            {{
                              this.clientForm.get([
                                "basicInformation",
                                "isResale",
                              ])?.value
                            }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col mb-4">
                      <div class="form-group switcher">
                        <label class="form-label d-block mb-2" for="taxExp"
                          >Tax Exemption</label
                        >
                        <div
                          class="form-check form-switch d-flex align-items-center gap-2 m-0 form-switch-hgt">
                          <p-toggleswitch
                            formControlName="isTaxExemption"
                            (change)="onTaxExemptionEnabled($event)"
                            id="flexSwitchCheckDefault3" />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckDefault3">
                            {{
                              this.clientForm.get([
                                "basicInformation",
                                "isTaxExemption",
                              ])?.value
                            }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clients-fileupload pt-3">
                    <strong class="title d-block mb-4"
                      >If Yes, PO# will be needed when creating order</strong
                    >
                    <div class="row">
                      <div class="col">
                        <div class="form-group mb-2">
                          <input
                            #resaleFileInput
                            jniAutoCompleteBlocker
                            type="file"
                            id="file"
                            name="file"
                            style="display: none"
                            [disabled]="isResaleToggleStatus"
                            (change)="getResaleCertificateFile($event)" />
                          <div
                            jniGlobalFileDrop
                            [maxFileSize]="10"
                            [maxFiles]="1"
                            [disabled]="isResaleToggleStatus"
                            (filesDropped)="onResaleCertificateDropped($event)"
                            (filesRejected)="onFilesRejected($event)"
                            class="resale-certificate-drop-zone">
                            <label
                              for="file"
                              class="d-flex align-items-center gap-2"
                              [ngClass]="{
                                'labelcolor-gray': isResaleToggleStatus,
                              }"
                              (click)="
                                !isResaleToggleStatus && resaleFileInput.click()
                              ">
                              <i class="pi pi-cloud-upload icon-blue mx-1"></i>
                              Resale
                            </label>
                            <span
                              class="text-primary small"
                              data-toggle="tooltip"
                              [title]="resaleCertificateFileName">
                              {{ resaleCertificateFileName }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="error"
                          *ngIf="resaleCertificateValidationMessage">
                          Please upload Resale certificate
                        </div>
                        <div class="error" *ngIf="resaleCertificateFileSize">
                          File must be less than 1 MB
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group mb-2">
                          <input
                            #taxExemptionFileInput
                            jniAutoCompleteBlocker
                            type="file"
                            id="file1"
                            name="file1"
                            style="display: none"
                            [disabled]="isTaxExemptionToggleStatus"
                            (change)="getTaxExemptionFile($event)" />
                          <div
                            jniGlobalFileDrop
                            [maxFileSize]="1"
                            [maxFiles]="1"
                            [disabled]="isTaxExemptionToggleStatus"
                            (filesDropped)="onTaxExemptionDropped($event)"
                            (filesRejected)="onFilesRejected($event)"
                            class="tax-exemption-drop-zone">
                            <label
                              for="file1"
                              class="d-flex align-items-center gap-2"
                              [ngClass]="{
                                'labelcolor-gray': isTaxExemptionToggleStatus,
                              }"
                              (click)="
                                !isTaxExemptionToggleStatus &&
                                  taxExemptionFileInput.click()
                              ">
                              <i class="pi pi-cloud-upload icon-blue mx-1"></i>
                              Tax Exemption
                            </label>
                            <span
                              *ngIf="taxExemptionRemove"
                              class="text-primary small"
                              data-toggle="tooltip"
                              [title]="taxExemptionFileName">
                              {{ taxExemptionFileName }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="error"
                          *ngIf="taxExemptionValidationMessage">
                          Please upload Tax Examption
                        </div>
                        <div class="error" *ngIf="taxExemptionFileSize">
                          File must be less than 1 MB
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="gray-bg-rounded">
                  <jni-address
                    [parent]="clientForm"
                    [formgroupName]="'addressInformation'"
                    [cityList]="cityList"
                    [countryRegionList]="countryRegionList"
                    [countyList]="countyList"
                    [districtList]="districtList"
                    [stateList]="stateList"
                    [isFromAddClient]="true"
                    class="col-4"></jni-address>
                </div>
              </div>

              <div class="col-4">
                <div class="gray-bg-rounded">
                  <h2 class="mb-4">Contact Information</h2>
                  <div formGroupName="clientInformation">
                    <h3 class="pb-2 mb-2 has-border-thin">
                      Client Information
                    </h3>
                    <div class="row">
                      <div class="mb-2">
                        <div class="form-group has-float-label">
                          <label for="fName">First Name</label>
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            pInputText
                            id="clientid"
                            class="form-control"
                            hidden
                            formControlName="clientContactSerialNumber" />
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            id="fName"
                            pInputText
                            name="fName"
                            placeholder=""
                            class="form-control"
                            formControlName="clientFirstNameD365"
                            [ngClass]="{
                              'has-error': formErrors['clientFirstNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['clientFirstNameD365']">
                            {{ formErrors["clientFirstNameD365"] }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="form-group has-float-label">
                          <label for="lName">Last Name</label>
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            pInputText
                            id="lName"
                            name="lName"
                            placeholder=""
                            class="form-control"
                            formControlName="clientLastNameD365"
                            [ngClass]="{
                              'has-error': formErrors['clientLastNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['clientLastNameD365']">
                            {{ formErrors["clientLastNameD365"] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label for="pNumber">Phone Number</label>
                      <input
                        jniAutoCompleteBlocker
                        type="text"
                        pInputText
                        id="pNumber"
                        name="pNumber"
                        placeholder=""
                        class="form-control"
                        jni-phone-number-formatting
                        formControlName="clientPhoneNumberD365"
                        [ngClass]="{
                          'has-error': formErrors['clientPhoneNumberD365'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['clientPhoneNumberD365']">
                        {{ formErrors["clientPhoneNumberD365"] }}
                      </span>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label for="eAddress">Email Address</label>
                      <input
                        jniAutoCompleteBlocker
                        type="email"
                        pInputText
                        id="eAddress"
                        name="eAddress"
                        placeholder=""
                        class="form-control"
                        formControlName="clientEmailAddressD365"
                        [ngClass]="{
                          'has-error': formErrors['clientEmailAddressD365'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['clientEmailAddressD365']">
                        {{ formErrors["clientEmailAddressD365"] }}
                      </span>
                    </div>
                    <div class="form-group has-float-label mb-4">
                      <label for="title">Title</label>
                      <input
                        jniAutoCompleteBlocker
                        type="text"
                        pInputText
                        id="title"
                        name="title"
                        placeholder=""
                        class="form-control"
                        formControlName="clientTitle"
                        [ngClass]="{ 'has-error': formErrors['clientTitle'] }"
                        (blur)="logValidationErrors()" />

                      <span class="error-msg" *ngIf="formErrors['clientTitle']">
                        {{ formErrors["clientTitle"] }}
                      </span>
                    </div>
                  </div>
                  <div formGroupName="invoiceInformation">
                    <h3 class="pb-2 mb-2 has-border-thin">Invoice</h3>
                    <div class="row">
                      <div class="mb-2">
                        <div class="form-group has-float-label">
                          <label for="E_FName">First Name</label>
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            id="invoiceid"
                            pInputText
                            class="form-control"
                            hidden
                            formControlName="invoiceContactSerialNumber" />
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            pInputText
                            id="E_FName"
                            name="E_FName"
                            placeholder=""
                            class="form-control"
                            formControlName="invoiceFirstNameD365"
                            [ngClass]="{
                              'has-error': formErrors['invoiceFirstNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['invoiceFirstNameD365']">
                            {{ formErrors["invoiceFirstNameD365"] }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="form-group has-float-label">
                          <label class="form-label" for="E_LName"
                            >Last Name</label
                          >
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            pInputText
                            id="E_LName"
                            name="E_LName"
                            placeholder=""
                            class="form-control"
                            formControlName="invoiceLastNameD365"
                            [ngClass]="{
                              'has-error': formErrors['invoiceLastNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['invoiceLastNameD365']">
                            {{ formErrors["invoiceLastNameD365"] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label for="E_PNumber">Phone Number</label>
                      <input
                        jniAutoCompleteBlocker
                        type="text"
                        pInputText
                        id="E_PNumber"
                        name="E_PNumber"
                        placeholder=""
                        class="form-control"
                        jni-phone-number-formatting
                        formControlName="invoicePhoneNumberD365"
                        [ngClass]="{
                          'has-error': formErrors['invoicePhoneNumberD365'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['invoicePhoneNumberD365']">
                        {{ formErrors["invoicePhoneNumberD365"] }}
                      </span>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="E_Address"
                        >Email Address
                        <span class="madatory-field">*</span></label
                      >
                      <input
                        jniAutoCompleteBlocker
                        type="email"
                        id="E_Address"
                        pInputText
                        name="E_Address"
                        class="form-control"
                        placeholder=""
                        formControlName="invoiceEmailAddressD365"
                        [ngClass]="{
                          'has-error': formErrors['invoiceEmailAddressD365'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['invoiceEmailAddressD365']">
                        {{ formErrors["invoiceEmailAddressD365"] }}
                      </span>
                    </div>
                  </div>
                  <div formGroupName="payableInformation">
                    <h3 class="mt-2 mb-4 has-border-thin">Payable</h3>
                    <div>
                      <div class="col mb-4">
                        <div class="form-group has-float-label">
                          <label class="form-label" for="P_FName"
                            >First Name</label
                          >
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            pInputText
                            id="payableid"
                            class="form-control"
                            hidden
                            formControlName="payableContactSerialNumber" />
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            id="P_FName"
                            pInputText
                            name="P_FName"
                            placeholder=""
                            class="form-control"
                            formControlName="payableFirstNameD365"
                            [ngClass]="{
                              'has-error': formErrors['payableFirstNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['payableFirstNameD365']">
                            {{ formErrors["payableFirstNameD365"] }}
                          </span>
                        </div>
                      </div>
                      <div class="col mb-4">
                        <div class="form-group has-float-label">
                          <label class="form-label" for="P_LName"
                            >Last Name</label
                          >
                          <input
                            jniAutoCompleteBlocker
                            type="text"
                            id="P_LName"
                            pInputText
                            name="P_LName"
                            placeholder=""
                            class="form-control"
                            formControlName="payableLastNameD365"
                            [ngClass]="{
                              'has-error': formErrors['payableLastNameD365'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['payableLastNameD365']">
                            {{ formErrors["payableLastNameD365"] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group has-float-label mb-4">
                      <label class="form-label" for="P_PNumber"
                        >Phone Number</label
                      >
                      <input
                        jniAutoCompleteBlocker
                        type="text"
                        id="P_PNumber"
                        name="P_PNumber"
                        pInputText
                        placeholder=""
                        class="form-control"
                        jni-phone-number-formatting
                        formControlName="payablePhoneNumberD365"
                        [ngClass]="{
                          'has-error': formErrors['payablePhoneNumberD365'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['payablePhoneNumberD365']">
                        {{ formErrors["payablePhoneNumberD365"] }}
                      </span>
                    </div>
                    <div class="form-group has-float-label mb-4">
                      <label class="form-label" for="P_Address"
                        >Email Address</label
                      >
                      <input
                        jniAutoCompleteBlocker
                        type="email"
                        id="P_Address"
                        pInputText
                        name="P_Address"
                        placeholder=""
                        class="form-control"
                        formControlName="payableEmailAddressD365"
                        [ngClass]="{
                          'has-error': formErrors['payableEmailAddressD365'],
                        }"
                        (blur)="logValidationErrors()" />

                      <span
                        class="error-msg"
                        *ngIf="formErrors['payableEmailAddressD365']">
                        {{ formErrors["payableEmailAddressD365"] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="d-flex py-3 has-sticky d-flex justify-content-end gap-2">
                <p-button
                  label="Cancel"
                  (onClick)="navigateToClientListing()"
                  severity="secondary" />

                <p-button label="Save" (click)="addNewClientData()" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-add-program-blade
  #addprogram
  [display]="displayAddProgram"
  (displayChange)="getAddProgramBarShowStatus($event)"
  (getProgramData)="patchProgramValues($event)"
  [threePLList]="threePLList"
  [platformList]="platformList"
  [facilitatorList]="facilitatorList">
</jni-add-program-blade>
